import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';

export const retirementTransactionService = createApi({
    reducerPath: 'retirementTransactionService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['RetirementTransaction'],
    endpoints: (builder) => ({
        getAllRetirementTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.search}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        saveRetirementTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.save}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateRetirementTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.update}/${body.payload.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteRetirementTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.delete}/${body.id}${body.type ? `?type=${body.type}` : ""}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getRetirementTransactionById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.getById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkUploadRetirementTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.uploadBulk}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        findAllRetirementTransaction: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.retirementTransactionController.findAll}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
    })
});

export const {
    useGetAllRetirementTransactionMutation,
    useSaveRetirementTransactionMutation,
    useUpdateRetirementTransactionMutation,
    useDeleteRetirementTransactionMutation,
    useGetRetirementTransactionByIdMutation,
    useBulkUploadRetirementTransactionMutation,
    useFindAllRetirementTransactionMutation,
} = retirementTransactionService;
